export var RegistrationType;
(function (RegistrationType) {
    RegistrationType[RegistrationType["Admin"] = 0] = "Admin";
    RegistrationType[RegistrationType["Self"] = 1] = "Self";
    RegistrationType[RegistrationType["Guardian"] = 2] = "Guardian";
})(RegistrationType || (RegistrationType = {}));
